import ResourceBody from './ResourceBody';

export default ResourceBody;
